import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type {
  AlternativeLoanReportConsumerSegment,
  AlternativeLoanReportAddress,
  AlternativeLoanReportInquirySegment,
  AlternativeLoanReportLoanSegment,
  AlternativeLoanReportSliceState,
  AlternativeLoanReportStatus,
} from './types';

const initialState: AlternativeLoanReportSliceState = {
  status: null,
  createdAt: null,
  consumerSegments: null,
  currentAddress: null,
  inquiries: [],
  loans: [],
};

interface SetReportPayload {
  status: AlternativeLoanReportStatus;
  createdAt?: string | null;
  consumerSegments?: AlternativeLoanReportConsumerSegment[] | null;
  currentAddress?: AlternativeLoanReportAddress | null;
  inquiries?: AlternativeLoanReportInquirySegment[];
  loans?: AlternativeLoanReportLoanSegment[];
}

const alternativeLoanReportSlice = createAppSlice({
  name: 'alternativeLoanReport',
  initialState,
  reducers: {
    setAlternativeLoanReport(state, action: PayloadAction<SetReportPayload>) {
      const { payload } = action;
      state.status = payload.status;
      state.createdAt = payload.createdAt ?? null;
      state.consumerSegments = payload.consumerSegments ?? null;
      state.currentAddress = payload.currentAddress ?? null;
      state.inquiries = payload.inquiries ?? [];
      state.loans = payload.loans ?? [];
    },
    clearAlternativeLoanReport() {
      return {
        status: null,
        createdAt: null,
        consumerSegments: null,
        currentAddress: null,
        inquiries: [],
        loans: [],
      };
    },
  },
});

export const { setAlternativeLoanReport, clearAlternativeLoanReport } =
  alternativeLoanReportSlice.actions;

export default alternativeLoanReportSlice.reducer;
